import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import * as pdfjsLib from 'pdfjs-dist';

// pdfjs 4.x renamed the worker to `.mjs`. The worker is copied out of
// node_modules into the public folder at build time (see package.json scripts)
// and served same-origin, so we no longer pin a versioned worker URL from a CDN.
const workerUrl = `${process.env.PUBLIC_URL || ''}/pdf.worker.min.mjs`;
pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrl;

function PdfView(props) {
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    toolbarPlugin: {
      getFilePlugin: {
        fileNameGenerator: (file) => {
          const url = file.name;
          const pathPart = url.split('?')[0];
          const encoded = pathPart.substring(pathPart.lastIndexOf('/') + 1);
          return decodeURIComponent(encoded);
        },
      },
    },
  });

  return (
    <div className='PdfView' style={{
      height: props.height,
      width: props.width
    }}>
      <Worker workerUrl={workerUrl}>
        <Viewer 
          fileUrl={props.fileUrl} 
          plugins={[defaultLayoutPluginInstance]} 
          defaultScale="PageFit"
        />
      </Worker>
    </div>
  );
}

export default PdfView;
